<template>
  <div class="modal fade custom-modal verify-modal" id="nexmo">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <div class="email-group">
            <h4>Nexmo</h4>
            <div class="active-switch me-2">
              <label class="switch">
                <input type="checkbox" checked="" />
                <span class="sliders round"></span>
              </label>
            </div>
          </div>
          <span>
            <a href="javascript:;" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>API Key <span> * </span></label>
            <input type="text" class="form-control" />
            <label>API Secret Key <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Sender ID <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <a href="javascript:;" class="btn btn-primary">Submit</a>
          <a href="javascript:;" class="btn btn-secondary">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</template>
